module.exports = __webpack_public_path__ + "static/media/bg3.57553a6a.jpg";